// @ts-ignore
import APIS from '../../../constant/Endpoint';
import DataTable from '../../Reusable/DataTable';
import NACell from '../../Reusable/DataTable/NACell';
import SwitchButton from '../../Reusable/SwitchButton/SwitchButton';

const EmailContent = (props: any) => {
  const { handleIsDefault } = props;
  const defaultColumns: any = [
    {
      header: 'Email',
      accessorKey: 'email',
      cell: NACell,
    },
    {
      header: 'Default',
      accessorKey: 'is_default',
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsDefault}
        />
      ),
    },
    // {
    //     header: "Date",
    //     accessorKey: "created_at",
    //     cell: ({ row, getValue }: any) => {
    //       return (
    //         <>
    //           {getValue() ? (
    //             <p className={tw`max-w-[80px]`}>
    //               {moment(getValue()).format("YY-MM-DD HH:mm:ss")}
    //             </p>
    //           ) : (
    //             "N/A"
    //           )}
    //         </>
    //       );
    //     },
    //   },
    //   {
    //   header: 'Contact Group',
    //   accessorKey: 'contact.id',
    //   cell: NACell,
    // },
  ];

  return (
    <DataTable
      url={APIS.SENDER_EMAIL}
      queryKey={'emails'}
      columns={defaultColumns}
      tableName={'Email'}
    />
  );
};

export default EmailContent;
